// sub-widget JS with PRICE PRELOAD (no first-click delay)
document.addEventListener('DOMContentLoaded', function () {
  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const fmt = (cents, currency = 'USD') =>
    new Intl.NumberFormat('en-US', { style: 'currency', currency }).format((cents || 0) / 100);

  // Default MSRP anchor per jar (1x one-time jar list price) — used as fallback
  // Individual widgets can override via data-msrp-cents="7500" on the .sub-widget root.
  const DEFAULT_SINGLE_OT_BASE_CENTS = 7200; // $72.00

  // --- PRODUCT CONFIG MAP (per-product variant IDs) ---
  const PRODUCT_CONFIG = {
    balance: {
      ONETIME_VARIANTS: { '1': 51950062534961, '3': 51950062567729, '5': 51950264090929 },
      SUB_VARIANTS:     { '1': 51974386843953, '3': 51950055981361, '5': 51950194557233 },
      SUB_PLANS:        { '1': 691814105393,   '3': 691810107697,   '5': 691810140465   }
    },
    passion: {
      ONETIME_VARIANTS: { '1': 51972289429809, '3': 51972289462577, '5': 51972289495345 },
      SUB_VARIANTS:     { '1': 51972395204913, '3': 51972395663665, '5': 51972395925809 },
      SUB_PLANS:        { '1': 691822166321,   '3': 691822199089,   '5': 691822231857   }
    },
    beauty: {
      ONETIME_VARIANTS: { '1': 51972829806897, '3': 51972829839665, '5': 51972829872433 },
      SUB_VARIANTS:     { '1': 51972975165745, '3': 51972976017713, '5': 51972976476465 },
      SUB_PLANS:        { '1': 691822985521,   '3': 691823018289,   '5': 691823051057 }
    },
    'mad-vag': {
      ONETIME_VARIANTS: { '1': 54173227647281, '3': 54173227680049, '5': 54173227712817 },
      SUB_VARIANTS:     { '1': 54179215573297, '3': 54179215606065, '5': 54179215638833 },
      SUB_PLANS:        { '1': 692360413489,   '3': 692360446257,   '5': 692360479025   }
    },
    'mad-focus': {
      ONETIME_VARIANTS: { '1': 54388082409777, '3': 54388082442545, '5': 54388082475313 },
      SUB_VARIANTS:     { '1': 54407967998257, '3': 54407968063793, '5': 54407968162097 },
      SUB_PLANS:        { '1': 692403241265,   '3': 692403274033,   '5': 692403306801   }
    },
    'mad-sleep': {
      ONETIME_VARIANTS: { '1': 54416195551537, '3': 54416195584305, '5': 54416195617073 },
      SUB_VARIANTS:     { '1': 54416198172977, '3': 54416198336817, '5': 54416198861105 },
      SUB_PLANS:        { '1': 692407632177,   '3': 692407664945,   '5': 692407697713   }
}
  };

  // pack index -> how many jars
  const PACK_QTY = { '1': 1, '3': 3, '5': 5 };

  // ---- Pricing cache + preload ----
  const vCache = {};
  async function loadVariant(id) {
    if (!id) throw new Error('Missing variant ID');
    if (vCache[id]) return vCache[id];
    const r = await fetch(`/variants/${id}.js`, { credentials: 'same-origin' });
    if (!r.ok) throw new Error('Price fetch failed for variant ' + id);
    const v = await r.json();
    vCache[id] = { price: v.price, compare: v.compare_at_price || null };
    return vCache[id];
  }

  async function preloadAllPrices(ONETIME_VARIANTS, SUB_VARIANTS) {
    const ids = new Set([...Object.values(ONETIME_VARIANTS), ...Object.values(SUB_VARIANTS)]);
    await Promise.all(Array.from(ids).map(id => loadVariant(id).catch(() => ({}))));
  }

  // ---- Drawer open helper ----
  function openCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    const trigger = document.querySelector('[aria-controls="CartDrawer"],[data-drawer-id="CartDrawer"],[data-cart-toggle],.js-drawer-open-cart,[data-action="open-drawer"][data-drawer="cart"]');
    if (trigger) { trigger.click(); return; }
    fetch('/cart.js').then(x => x.json()).then(cart => {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart } }));
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart } }));
    }).catch(() => { });
  }

  // ---- Init each widget on the page ----
  $$('.sub-widget').forEach(async root => {
    // which product?
    const handle = root.getAttribute('data-product');
    const cfg = PRODUCT_CONFIG[handle];
    if (!cfg) {
      console.error('No PRODUCT_CONFIG for handle:', handle);
      return;
    }

    const ONETIME_VARIANTS = cfg.ONETIME_VARIANTS;
    const SUB_VARIANTS     = cfg.SUB_VARIANTS;
    const SUB_PLANS        = cfg.SUB_PLANS;

    // Per-widget MSRP anchor — falls back to default if not set
    const SINGLE_OT_BASE_CENTS =
      parseInt(root.getAttribute('data-msrp-cents'), 10) || DEFAULT_SINGLE_OT_BASE_CENTS;

    root.classList.add('sub-widget-loading');

    // Default state: subscribe, 3-pack
    const state = { mode: 'subscribe', pack: '3' };

    // Sync active UI before first render (prevent flash)
    $$('.pack-btn', root).forEach(b => {
      const active = b.dataset.pack === state.pack;
      b.classList.toggle('active', active);
      b.setAttribute('aria-pressed', String(active));
    });
    $$('.toggle-btn', root).forEach(b => {
      const active = b.dataset.mode === state.mode;
      b.classList.toggle('active', active);
      b.setAttribute('aria-selected', String(active));
    });

    const currency = root.getAttribute('data-currency') || 'USD';
    const subDiscountPct = parseFloat(root.getAttribute('data-sub-discount-pct') || '') || null;

    // Elements
    const elSubType   = $('.type-price[data-type="subscribe"]', root);
    const elOTType    = $('.type-price[data-type="onetime"]', root);
    const elNote      = $('.pack-note', root);
    const elCmp       = $('.cta-compare', root);
    const elTotal     = $('.cta-total', root);
    const elAdd       = $('.cta', root);
    const feedback    = $('.feedback', root);

    const elBeforeSub = $('.toggle-btn-sub .before-price', root);
    const elBeforeOT  = $('.toggle-btn[data-mode="onetime"] .before-price', root);

    const elSaleBadge = $('.sale-badge', root);

    // ONLY badge we manage for savings is 1-jar
    const badge1 = $('.pack-btn[data-pack="1"] .callout-note', root) ||
                   $('.pack-btn[data-pack="1"] + .callout-note', root);

    const NOTE = {
      subscribe: {
        '1': '1 Jar / Month',
        '3': '3 Jars / 3 Months',
        '5': '5 Jars / 5 Months'
      },
      onetime: {
        '1': '1 Jar',
        '3': '3 Jars',
        '5': '5 Jars'
      }
    };

    await preloadAllPrices(ONETIME_VARIANTS, SUB_VARIANTS);

    async function currentTotalCents(mode, pack) {
      const vid = (mode === 'subscribe') ? SUB_VARIANTS[pack] : ONETIME_VARIANTS[pack];
      const { price } = await loadVariant(vid);

      // fallback discount path if same variant used for sub vs ot
      if (mode === 'subscribe' && SUB_VARIANTS[pack] === ONETIME_VARIANTS[pack] && subDiscountPct) {
        return Math.round(price * (1 - subDiscountPct / 100));
      }
      return price;
    }

    async function pricePerJarCents(mode, pack) {
      const total = await currentTotalCents(mode, pack);
      return Math.round(total / PACK_QTY[pack]);
    }

    async function renderPackButtonPrices() {
      const mode = state.mode;
      const btns = $$('.pack-btn', root);

      await Promise.all(btns.map(async btn => {
        const pack = btn.dataset.pack;
        const perJarCents = await pricePerJarCents(mode, pack);
        const priceEl = $('.pack-price', btn);
        if (priceEl) {
          priceEl.textContent = fmt(perJarCents, currency);
        }
      }));
    }

    async function renderTypePerJar() {
      const pack = state.pack;
      const qty  = PACK_QTY[pack];

      const otTotal  = await currentTotalCents('onetime', pack);
      const subTotal = await currentTotalCents('subscribe', pack);

      const otPerJarCents  = Math.round(otTotal  / qty);
      const subPerJarCents = Math.round(subTotal / qty);

      elOTType.textContent  = fmt(otPerJarCents,  currency);
      elSubType.textContent = fmt(subPerJarCents, currency);

      // crossed-out price in Subscribe row -> always show MSRP
      if (elBeforeSub) {
        elBeforeSub.style.display = '';
        elBeforeSub.textContent = fmt(SINGLE_OT_BASE_CENTS, currency);
      }

      // crossed-out price in One Time row -> show MSRP only for 3/5 packs
      if (elBeforeOT) {
        const show = (pack === '3' || pack === '5');
        if (show) {
          elBeforeOT.style.display = '';
          elBeforeOT.textContent = fmt(SINGLE_OT_BASE_CENTS, currency);
        } else {
          elBeforeOT.style.display = 'none';
          elBeforeOT.textContent = '';
        }
      }
    }

    async function renderSavingsBadges() {
      if (!badge1) return;

      const singleOTTotal = await currentTotalCents('onetime', '1'); // cents for 1 jar OT
      const actual1       = await currentTotalCents(state.mode, '1'); // cents for 1 jar current mode
      const diff1         = singleOTTotal - actual1;

      if (diff1 > 0) {
        const formatted1 = fmt(diff1, currency).replace('.00', '');
        badge1.style.display = '';
        badge1.textContent = `Save ${formatted1}`;
      } else {
        badge1.style.display = 'none';
        badge1.textContent = '';
      }
    }

    async function renderTotals() {
      const pack = state.pack;
      const mode = state.mode;

      if (elNote) {
        elNote.textContent = NOTE[mode][pack];
      }

      const vidActive = (mode === 'onetime')
        ? ONETIME_VARIANTS[pack]
        : SUB_VARIANTS[pack];

      const { price: activePrice, compare: activeCompare } = await loadVariant(vidActive);

      if (elTotal) {
        elTotal.textContent = fmt(activePrice, currency);
      }

      if (elCmp) {
        if (activeCompare && activeCompare > activePrice) {
          elCmp.style.display = '';
          elCmp.textContent = fmt(activeCompare, currency);
        } else {
          elCmp.style.display = 'none';
          elCmp.textContent = '';
        }
      }

      if (elSaleBadge) {
        const qty = PACK_QTY[pack];
        const subTotalCents = await currentTotalCents('subscribe', pack);
        const subPerJar = subTotalCents / qty;

        const msrpPerJar = SINGLE_OT_BASE_CENTS;
        const diff = msrpPerJar - subPerJar;

        if (diff > 0 && msrpPerJar > 0) {
          const pct = Math.round((diff / msrpPerJar) * 100);
          elSaleBadge.style.display = '';
          elSaleBadge.textContent = pct + '% OFF';
        } else {
          elSaleBadge.style.display = 'none';
          elSaleBadge.textContent = '';
        }
      }
    }

    async function renderAll() {
      await renderPackButtonPrices();
      await renderTypePerJar();
      await renderTotals();
      await renderSavingsBadges();
      root.classList.remove('sub-widget-loading');
    }

    // interactions
    $$('.toggle-btn', root).forEach(btn => {
      btn.addEventListener('click', async e => {
        e.preventDefault();
        e.stopPropagation();

        $$('.toggle-btn', root).forEach(b => {
          b.classList.remove('active');
          b.setAttribute('aria-selected', 'false');
        });

        btn.classList.add('active');
        btn.setAttribute('aria-selected', 'true');
        state.mode = btn.dataset.mode;

        await renderAll();
      });
    });

    $$('.pack-btn', root).forEach(btn => {
      btn.addEventListener('click', async e => {
        e.preventDefault();
        e.stopPropagation();

        $$('.pack-btn', root).forEach(b => {
          b.classList.remove('active');
          b.setAttribute('aria-pressed', 'false');
        });

        btn.classList.add('active');
        btn.setAttribute('aria-pressed', 'true');
        state.pack = btn.dataset.pack;

        await renderAll();
      });
    });

    // Prevent any parent form from hijacking submit
    if (elAdd) elAdd.setAttribute('type', 'button');
    const form = root.closest('form');
    if (form) {
      form.addEventListener(
        'submit',
        e => {
          e.preventDefault();
          e.stopImmediatePropagation();
          return false;
        },
        true
      );
    }

    // Add To Cart
    if (elAdd) {
      elAdd.addEventListener('click', async e => {
        e.preventDefault();
        e.stopPropagation();
        try {
          if (feedback) feedback.textContent = '';

          const pack = state.pack;
          const mode = state.mode;
          const vid  = (mode === 'onetime') ? ONETIME_VARIANTS[pack] : SUB_VARIANTS[pack];
          const plan = (mode === 'subscribe') ? SUB_PLANS[pack] : null;

          const body = new URLSearchParams();
          body.append('items[0][id]', String(vid));
          body.append('items[0][quantity]', '1');
          if (plan) body.append('items[0][selling_plan]', String(plan));

          const r = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
            body
          });
          if (!r.ok) throw new Error('Add to cart failed');

          openCartDrawer();
        } catch (err) {
          if (feedback) feedback.textContent = err.message || 'Something went wrong.';
          console.error(err);
        }
      }, true);
    }

    // first render
    await renderAll();
  });
});

// Pre-seed visible text instantly (so no blank prices on first paint for default state)
// Reads optional data-* preseed values from the root for per-product accuracy;
// falls back to the original passion/balance numbers if not provided.
(function () {
  var roots = document.querySelectorAll('.sub-widget');
  if (!roots.length) return;

  roots.forEach(function (root) {
    // Read optional per-product preseed values from data attributes
    var msrpCents = parseInt(root.getAttribute('data-msrp-cents'), 10) || 7200;
    var msrpStr   = '$' + (msrpCents / 100).toFixed(2);

    var sub = root.querySelector('.type-price[data-type="subscribe"]');
    var ot  = root.querySelector('.type-price[data-type="onetime"]');
    var cmp = root.querySelector('.cta-compare');
    var tot = root.querySelector('.cta-total');

    var beforeSub = root.querySelector('.toggle-btn-sub .before-price');
    var beforeOT  = root.querySelector('.toggle-btn[data-mode="onetime"] .before-price');

    var badge1 = root.querySelector('.pack-btn[data-pack="1"] .callout-note') ||
                 root.querySelector('.pack-btn[data-pack="1"] + .callout-note');

    // Optional per-product preseed values (defaults match the original $72 passion preseed)
    var PRESEED = {
      subPerJar:  root.getAttribute('data-preseed-sub-perjar')  || '$38.00',
      otPerJar:   root.getAttribute('data-preseed-ot-perjar')   || '$48.00',
      atcCompare: root.getAttribute('data-preseed-atc-compare') || '$216.00',
      atcTotal:   root.getAttribute('data-preseed-atc-total')   || '$114.00',
      badge1Text: root.getAttribute('data-preseed-badge1')      || 'Save $15',
      saleBadge:  root.getAttribute('data-preseed-sale-badge')  || '47% OFF',
      beforePerJar: msrpStr
    };

    if (sub) sub.textContent = PRESEED.subPerJar;
    if (ot)  ot.textContent  = PRESEED.otPerJar;

    if (cmp) { cmp.textContent = PRESEED.atcCompare; cmp.style.display = ''; }
    if (tot) tot.textContent = PRESEED.atcTotal;

    var note = root.querySelector('.pack-note');
    if (note) note.textContent = '3 Jars / 3 Months';

    if (beforeSub) { beforeSub.style.display = ''; beforeSub.textContent = PRESEED.beforePerJar; }
    if (beforeOT)  { beforeOT.style.display  = ''; beforeOT.textContent  = PRESEED.beforePerJar; }

    if (badge1) { badge1.style.display = ''; badge1.textContent = PRESEED.badge1Text; }

    var saleBadge = root.querySelector('.sale-badge');
    if (saleBadge) {
      saleBadge.style.display = '';
      saleBadge.textContent = PRESEED.saleBadge;
    }
  });
})();